import {
  Modal,
  ModalContent,
  ModalFooter,
  TextInput
} from "@dealer-center/core-components";
import { useDealerCodeMappingEdit } from "@dealer-center/ddc-pages-dealer-codes-fetch";
import { useEffect, useState } from "react";
import { SaveAndCancel } from "@dealer-center/core-custom-components";
import { useToaster } from "@dealer-center/core-components";
import type { dealerCodeMappingEditModalInterface } from "./helper";
import { DuplicateDealerCodeValueWarning } from "./duplicate-dealer-code-value-warning";

interface DealerCodesEditModalProps {
  show: boolean;
  close: () => void;
  values: dealerCodeMappingEditModalInterface;
}
export const DealerCodesEditModal = ({
  close,
  values,
  show
}: DealerCodesEditModalProps) => {
  const { account, dealerCode, dealerCodeType, id } = values;
  useEffect(() => {
    if (!values) return;
    setAddDealerCodeToDealerInputString(dealerCode);
  }, []);
  const [
    addDealerCodeToDealerInputString,
    setAddDealerCodeToDealerInputString
  ] = useState<string>(dealerCode);
  const { toastError, toastSuccess } = useToaster();
  const { mutate, isError, isSuccess, isPending } = useDealerCodeMappingEdit();
  if (isError) {
    toastError("Error editing dealer code mapping");
    close();
  }
  if (isSuccess) {
    toastSuccess(
      "Success",
      `Dealer code mapping ${dealerCode} edited successfully`
    );
    close();
  }
  if (!dealerCode) return null;

  return (
    <Modal
      className="sample-modal-dialog"
      footer={{
        primary: {
          label: "unused"
        },
        footerComponent: (
          <ModalFooter>
            <SaveAndCancel
              analyticsEventName="Dealer Code Edit"
              isDisabled={{
                save:
                  addDealerCodeToDealerInputString === "" ||
                  addDealerCodeToDealerInputString === dealerCode
              }}
              isSaving={isPending}
              saveButtonText="Edit"
              onCancel={close}
              onSave={() => {
                mutate({
                  accountId: account.id,
                  id,
                  dealerCode: addDealerCodeToDealerInputString,
                  dealerCodeType
                });
              }}
            />
          </ModalFooter>
        )
      }}
      header={`Edit Dealer Code ${dealerCodeType} for ${
        account.displayName || account.id
      }`}
      show={show}
      size="small"
      onHide={close}
    >
      <ModalContent>
        <TextInput
          id="edit-dealer-code-input"
          label="Dealer Code Value"
          name="edit-dealer-code-input"
          value={addDealerCodeToDealerInputString?.toString()}
          onChange={e => {
            setAddDealerCodeToDealerInputString(e.target.value);
          }}
        />
        <DuplicateDealerCodeValueWarning
          currentAccountId={account.id}
          dealerCodeVType={dealerCodeType}
          dealerCodeValue={addDealerCodeToDealerInputString}
        />
      </ModalContent>
    </Modal>
  );
};
